function updateObject(state, action, actionType) {
  switch (action.type) {
    case actionType:
      return Object.assign({}, state, {
        items: action.items
      });
    default:
      return state;
  }
}

export const income = (state = [], action) => {
  return updateObject(state, action, 'INCOME')
}

export const paymentDocument = (state = [], action) => {
  return updateObject(state, action, 'PAYMENT_DOCUMENT')
}

export const notificationsCount = (state = [], action) => {
  return updateObject(state, action, 'NOTIFICATIONS_COUNT')
}

export const contragent = (state = [], action) => {
  return updateObject(state, action, 'CONTRAGENT')
}

export const notifications = (state = [], action) => {
  return updateObject(state, action, 'NOTIFICATIONS')
}

export const partnerSettings = (state = [], action) => {
  return updateObject(state, action, 'PARTNER_SETTINGS')
}

/*
export const updateDialog = (state = [], action) => {
  return updateObject(state, action, 'DIALOG')
}*/
